import { logger } from "./logger";
import { getVoiceLang } from "./voicePref";
// Ular Kata Ceria - Snake Educational Game Data

export const SNAKE_LEVELS = [
  {
    id: 1,
    name: "Huruf Tunggal",
    icon: "A",
    color: "#FF6B6B",
    desc: "Cari huruf yang diminta!",
    type: "single_letter",
    speed: 450,
    questions: [
      { mission: "Ambil huruf A", correct: "A", pool: ["A","B","C","D","E","F"] },
      { mission: "Ambil huruf B", correct: "B", pool: ["A","B","C","D","E","F"] },
      { mission: "Ambil huruf C", correct: "C", pool: ["A","B","C","D","G","H"] },
      { mission: "Ambil huruf D", correct: "D", pool: ["A","B","D","E","F","G"] },
      { mission: "Ambil huruf E", correct: "E", pool: ["A","E","C","D","F","H"] },
      { mission: "Ambil huruf F", correct: "F", pool: ["B","F","C","D","E","G"] },
      { mission: "Ambil huruf G", correct: "G", pool: ["A","G","C","D","E","F"] },
      { mission: "Ambil huruf H", correct: "H", pool: ["A","H","C","D","E","F"] },
    ],
  },
  {
    id: 2,
    name: "Angka Tunggal",
    icon: "1",
    color: "#4ECDC4",
    desc: "Ambil angka yang benar!",
    type: "single_number",
    speed: 420,
    questions: [
      { mission: "Ambil angka 3", correct: "3", pool: ["1","2","3","4","5","6"] },
      { mission: "Ambil angka 7", correct: "7", pool: ["5","6","7","8","9","10"] },
      { mission: "Ambil angka 1", correct: "1", pool: ["1","2","3","4","5","6"] },
      { mission: "Ambil angka 5", correct: "5", pool: ["3","4","5","6","7","8"] },
      { mission: "Ambil angka 9", correct: "9", pool: ["6","7","8","9","10","1"] },
      { mission: "Ambil angka 4", correct: "4", pool: ["1","2","3","4","5","6"] },
      { mission: "Ambil angka 8", correct: "8", pool: ["5","6","7","8","9","10"] },
      { mission: "Ambil angka 2", correct: "2", pool: ["1","2","3","4","5","6"] },
    ],
  },
  {
    id: 3,
    name: "Susun Kata Pendek",
    icon: "IBU",
    color: "#A855F7",
    desc: "Susun kata dengan urutan benar!",
    type: "spell_word",
    speed: 400,
    questions: [
      { mission: "Susun kata: IBU", correct: ["I","B","U"], pool: ["I","B","U","A","E","K"] },
      { mission: "Susun kata: API", correct: ["A","P","I"], pool: ["A","P","I","O","U","E"] },
      { mission: "Susun kata: AIR", correct: ["A","I","R"], pool: ["A","I","R","E","S","U"] },
      { mission: "Susun kata: DUA", correct: ["D","U","A"], pool: ["D","U","A","E","I","O"] },
      { mission: "Susun kata: BUKU", correct: ["B","U","K","U"], pool: ["B","U","K","U","A","E","I"] },
      { mission: "Susun kata: BOLA", correct: ["B","O","L","A"], pool: ["B","O","L","A","E","I","U"] },
    ],
  },
  {
    id: 4,
    name: "Hewan & Buah",
    icon: "🍎",
    color: "#F97316",
    desc: "Susun nama dari petunjuk gambar!",
    type: "spell_word",
    speed: 380,
    questions: [
      { mission: "🍎 Susun kata: APEL", correct: ["A","P","E","L"], pool: ["A","P","E","L","I","O","U"] },
      { mission: "🐱 Susun kata: KUCING", correct: ["K","U","C","I","N","G"], pool: ["K","U","C","I","N","G","A","E"] },
      { mission: "🐟 Susun kata: IKAN", correct: ["I","K","A","N"], pool: ["I","K","A","N","E","U","O"] },
      { mission: "🍌 Susun kata: PISANG", correct: ["P","I","S","A","N","G"], pool: ["P","I","S","A","N","G","E","U"] },
      { mission: "🐰 Susun kata: KELINCI", correct: ["K","E","L","I","N","C","I"], pool: ["K","E","L","I","N","C","I","A"] },
      { mission: "🍊 Susun kata: JERUK", correct: ["J","E","R","U","K"], pool: ["J","E","R","U","K","A","I","O"] },
    ],
  },
  {
    id: 5,
    name: "Hitung Sederhana",
    icon: "➕",
    color: "#EAB308",
    desc: "Hitung dan ambil jawabannya!",
    type: "math",
    speed: 400,
    questions: [
      { mission: "2 + 1 = ?", correct: "3", pool: ["1","2","3","4","5","6"] },
      { mission: "3 + 2 = ?", correct: "5", pool: ["3","4","5","6","7","8"] },
      { mission: "4 + 3 = ?", correct: "7", pool: ["5","6","7","8","9","10"] },
      { mission: "5 - 2 = ?", correct: "3", pool: ["1","2","3","4","5","6"] },
      { mission: "6 + 4 = ?", correct: "10", pool: ["7","8","9","10","6","5"] },
      { mission: "8 - 3 = ?", correct: "5", pool: ["3","4","5","6","7","8"] },
      { mission: "1 + 1 = ?", correct: "2", pool: ["1","2","3","4","5","6"] },
      { mission: "9 - 4 = ?", correct: "5", pool: ["3","4","5","6","7","8"] },
    ],
  },
  {
    id: 6,
    name: "Kata Panjang",
    icon: "🌟",
    color: "#10B981",
    desc: "Susun kata yang lebih panjang!",
    type: "spell_word",
    speed: 380,
    questions: [
      { mission: "Susun: SEKOLAH", correct: ["S","E","K","O","L","A","H"], pool: ["S","E","K","O","L","A","H","I","U"] },
      { mission: "Susun: MATAHARI", correct: ["M","A","T","A","H","A","R","I"], pool: ["M","A","T","A","H","A","R","I","E"] },
      { mission: "Susun: KUPU-KUPU", correct: ["K","U","P","U","K","U","P","U"], pool: ["K","U","P","U","K","U","P","U","A"] },
      { mission: "Susun: PELANGI", correct: ["P","E","L","A","N","G","I"], pool: ["P","E","L","A","N","G","I","O","U"] },
      { mission: "Susun: BUNGA", correct: ["B","U","N","G","A"], pool: ["B","U","N","G","A","E","I","O"] },
      { mission: "Susun: BINTANG", correct: ["B","I","N","T","A","N","G"], pool: ["B","I","N","T","A","N","G","E","U"] },
    ],
  },
  {
    id: 7,
    name: "Huruf Besar Kecil",
    icon: "Aa",
    color: "#EC4899",
    desc: "Cari pasangan huruf besar dan kecil!",
    type: "single_letter",
    speed: 380,
    questions: [
      { mission: "Ambil huruf besar A", correct: "A", pool: ["A","a","b","B","c","C"] },
      { mission: "Ambil huruf kecil b", correct: "b", pool: ["a","B","b","C","d","E"] },
      { mission: "Ambil huruf besar M", correct: "M", pool: ["m","M","n","N","p","P"] },
      { mission: "Ambil huruf kecil s", correct: "s", pool: ["S","s","t","T","r","R"] },
      { mission: "Ambil huruf besar K", correct: "K", pool: ["k","K","l","L","j","J"] },
      { mission: "Ambil huruf kecil h", correct: "h", pool: ["H","h","g","G","i","I"] },
    ],
  },
  {
    id: 8,
    name: "Hitung Kelipatan",
    icon: "\u00D7",
    color: "#F59E0B",
    desc: "Pilih hasil perkalian yang benar!",
    type: "single_number",
    speed: 360,
    questions: [
      { mission: "2 x 4 = ?", correct: "8", pool: ["4","6","8","10","12","16"] },
      { mission: "3 x 3 = ?", correct: "9", pool: ["6","8","9","10","12","15"] },
      { mission: "5 x 2 = ?", correct: "10", pool: ["8","9","10","12","15","20"] },
      { mission: "4 x 4 = ?", correct: "16", pool: ["8","12","14","16","18","20"] },
      { mission: "6 x 2 = ?", correct: "12", pool: ["10","11","12","14","15","18"] },
      { mission: "2 x 7 = ?", correct: "14", pool: ["10","12","13","14","15","16"] },
    ],
  },
  {
    id: 9,
    name: "Buah Indonesia",
    icon: "\uD83C\uDF4D",
    color: "#16A34A",
    desc: "Susun nama buah!",
    type: "spell_word",
    speed: 380,
    questions: [
      { mission: "Susun: DURIAN", correct: ["D","U","R","I","A","N"], pool: ["D","U","R","I","A","N","O","E"] },
      { mission: "Susun: SALAK", correct: ["S","A","L","A","K"], pool: ["S","A","L","A","K","I","O","B"] },
      { mission: "Susun: RAMBUTAN", correct: ["R","A","M","B","U","T","A","N"], pool: ["R","A","M","B","U","T","A","N","O"] },
      { mission: "Susun: NANAS", correct: ["N","A","N","A","S"], pool: ["N","A","N","A","S","I","O","B"] },
      { mission: "Susun: APEL", correct: ["A","P","E","L"], pool: ["A","P","E","L","I","O","U","B"] },
      { mission: "Susun: JERUK", correct: ["J","E","R","U","K"], pool: ["J","E","R","U","K","I","O","B"] },
    ],
  },
  {
    id: 10,
    name: "Master Ular",
    icon: "\uD83D\uDC51",
    color: "#7C3AED",
    desc: "Tantangan terakhir, semua tipe!",
    type: "spell_word",
    speed: 320,
    questions: [
      { mission: "Susun: INDONESIA", correct: ["I","N","D","O","N","E","S","I","A"], pool: ["I","N","D","O","N","E","S","I","A","R"] },
      { mission: "Susun: BENDERA", correct: ["B","E","N","D","E","R","A"], pool: ["B","E","N","D","E","R","A","O","I"] },
      { mission: "Susun: GAJAH", correct: ["G","A","J","A","H"], pool: ["G","A","J","A","H","E","I","K"] },
      { mission: "Susun: SEPATU", correct: ["S","E","P","A","T","U"], pool: ["S","E","P","A","T","U","O","I"] },
      { mission: "Susun: BUKU", correct: ["B","U","K","U"], pool: ["B","U","K","U","A","I","O","E"] },
      { mission: "Susun: KAMAR", correct: ["K","A","M","A","R"], pool: ["K","A","M","A","R","E","I","O"] },
    ],
  },
];

// Grid config
export const GRID_COLS = 14;
export const GRID_ROWS = 10;

// Directions
export const DIR = {
  UP: { r: -1, c: 0 },
  DOWN: { r: 1, c: 0 },
  LEFT: { r: 0, c: -1 },
  RIGHT: { r: 0, c: 1 },
};

// Initial snake
export const getInitialSnake = () => [
  { r: 5, c: 4 },
  { r: 5, c: 3 },
  { r: 5, c: 2 },
];

// Shuffle array
export const shuffleArray = (arr) => {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
};

// Spawn food items on grid (avoiding snake positions)
export const spawnItems = (snake, pool, correctValue, gridRows, gridCols, existingItems = []) => {
  const occupied = new Set();
  snake.forEach(s => occupied.add(`${s.r},${s.c}`));
  existingItems.forEach(item => occupied.add(`${item.r},${item.c}`));

  const items = [];
  const shuffledPool = shuffleArray(pool);
  
  // Place 4-6 items
  const count = Math.min(shuffledPool.length, 5);
  let hasCorrect = false;

  for (let i = 0; i < count; i++) {
    let r, c, attempts = 0;
    do {
      r = Math.floor(Math.random() * gridRows);
      c = Math.floor(Math.random() * gridCols);
      attempts++;
    } while (occupied.has(`${r},${c}`) && attempts < 100);

    if (attempts >= 100) continue;
    occupied.add(`${r},${c}`);

    const value = shuffledPool[i];
    const isCorrect = Array.isArray(correctValue) ? value === correctValue[0] : value === correctValue;
    if (isCorrect) hasCorrect = true;

    items.push({ r, c, value, isCorrect });
  }

  // Ensure at least one correct item
  if (!hasCorrect && items.length > 0) {
    const cv = Array.isArray(correctValue) ? correctValue[0] : correctValue;
    items[0].value = cv;
    items[0].isCorrect = true;
  }

  return items;
};

// Sound effects
export const playEatSound = () => {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.frequency.setValueAtTime(600, ctx.currentTime);
    osc.frequency.exponentialRampToValueAtTime(1200, ctx.currentTime + 0.1);
    gain.gain.setValueAtTime(0.15, ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.2);
    osc.start();
    osc.stop(ctx.currentTime + 0.2);
  } catch (err) { logger.debug("audio op failed", err); }
};

export const playWrongSound = () => {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.frequency.setValueAtTime(300, ctx.currentTime);
    osc.frequency.exponentialRampToValueAtTime(150, ctx.currentTime + 0.3);
    gain.gain.setValueAtTime(0.12, ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.3);
    osc.start();
    osc.stop(ctx.currentTime + 0.3);
  } catch (err) { logger.debug("audio op failed", err); }
};

export const playLevelUpSound = () => {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    [523, 659, 784, 1047].forEach((freq, i) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0.12, ctx.currentTime + i * 0.12);
      gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + i * 0.12 + 0.2);
      osc.start(ctx.currentTime + i * 0.12);
      osc.stop(ctx.currentTime + i * 0.12 + 0.2);
    });
  } catch (err) { logger.debug("audio op failed", err); }
};

export const speakMission = (text) => {
  try {
    if ('speechSynthesis' in window) {
      window.speechSynthesis.cancel();
      const u = new SpeechSynthesisUtterance(text);
      u.lang = getVoiceLang();
      u.rate = 0.85;
      u.pitch = 1.0;
      window.speechSynthesis.speak(u);
    }
  } catch (err) { logger.debug("audio op failed", err); }
};
